export default "__VITE_ASSET__DXuBtQUz__"